<template>
        <div v-for="(field, key) in fields" style="margin-bottom:4px;" class="flex border rounded border-gray-200 p-4 flex-col">
            <div class="field w-full px-3 mb-3">
            <JetLabel
                class="w-full"
                for="nama_barang"
                value="Nama Barang / Peralatan"
            />
            <Input
                id="nama_barang"
                v-model="field.nama_barang"
                type="text"
                placeholder="Nama Barang"
                class="mt-1 block w-full"
            />
            </div>
            <div class="field w-full px-3 mb-3">
            <JetLabel
                class="w-full"
                for="jumlah_barang"
                value="Jumlah Barang"
            />
            <Input
                id="jumlah_barang"
                v-model="field.jumlah_barang"
                type="number"
                placeholder="Jumlah Barang"
                class="mt-1 block w-full"
            />
            </div>
            <div class="field w-full px-3" >
                    <ButtonDelete type="button" @click="RemoveField(key)" ><i class="fas fa-times-circle"></i></ButtonDelete>
            </div>
        </div>
        <div class="field w-full px-3 mb-3 mt-5" >
            <ButtonAdd type="button" @click="AddField" label="Tambah" ><i class="fas fa-plus-circle"></i> Tambah</ButtonAdd>
        </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import Input from "@/Components/Input.vue";
    import ButtonAdd from "@/Components/ButtonAdd.vue";
    import ButtonDelete from "@/Components/ButtonDelete.vue";

    import JetLabel from "@/Jetstream/Label.vue";

    export default defineComponent({
        components: {
            Input,
            ButtonAdd,
            ButtonDelete,
            JetLabel
        },
        name: 'InputRepeaterBarang',
        props: {
            modelValue: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                fields: [{}]
            }
        },
        computed: {
            model: {
                get: function (){
                    return this.modelValue;
                },
                set: function (value) {
                    this.$emit('update:modelValue', value);
                }
            }
        },
        mounted() {
            // this.fields = Vue.util.extend([{}], this.modelValue);
            // fire.$on('reset', this.resetField);
            // this.$emit('modelValue', this.fields);
            this.fields = this.modelValue;
            // console.log(this.modelValue);
        },
        methods: {
            AddField() {
                this.$emit('modelValue', this.fields);
                this.fields.push({});
                // this.fields = this.modelValue;
                // console.log(this.fields);
            },
            RemoveField(key) {
                this.fields.splice(key, 1);
            },
            resetField() {
                this.fields = [{}];
            },

        },
    });
</script>
